<template>
  <input
    class="block w-full h-10 p-2 placeholder-gray-400 border border-gray-300 rounded appearance-none bg-color"
    :class="{ 'bg-gray-50': $attrs.readonly || $attrs.readonly === 'readonly' }"
    :type="type"
    :value="value"
    v-on="listeners"
  />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    value: [String, Number],
  },
  computed: {
    listeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.$emit("input", event.target.value);
        },
      });
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: inherit;
}
</style>
